import { render, staticRenderFns } from "./ArtistsFilters.vue?vue&type=template&id=2baadab6"
import script from "./ArtistsFilters.vue?vue&type=script&lang=js"
export * from "./ArtistsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports